<template>
  <div class="modal-overlay">
    <div class="modal-card">
      
      <div class="icon-box warning-bg border-round-lg flex align-items-center justify-content-center mb-4">
        <i class="pi pi-exclamation-triangle text-xl warning-text"></i>
      </div>

      <h2 class="text-xl font-bold mb-2 title-brown">We are sorry to hear you go</h2>
      <p class="text-600 mb-5 text-sm px-2">
        Before we proceed to delete your account, please verify your account by entering your password
      </p>

      <div class="w-full text-left mb-5 px-8">
        <label class="block text-sm font-medium text-800 mb-2">
          Password<span class="text-red-500">*</span>
        </label>
        <IconField iconPosition="left" class="w-full">
          <InputIcon class="pi pi-lock" />
          <Password 
            v-model="password" 
            toggleMask
            :feedback="false"
            placeholder="Enter your password" 
            class="w-full" 
            inputClass="w-full"
            :disabled="isLoading" 
          />
        </IconField>

        <small class="p-error flex align-items-center mt-2  error-placeholder">
          {{ error }}
        </small>
      </div>

      <Button 
        label="Process" 
        class="w-14rem"
        :class="buttonClass" 
        :loading="isLoading" 
        @click="$emit('next', password)" 
        :disabled="!password" 
      />
      
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineEmits, defineProps } from 'vue';
import Password from 'primevue/password';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';

const props = defineProps({
  isLoading: { type: Boolean, default: false },
  error: { type: String, default: null },
  role: { type: String, default: 'student' }
});

defineEmits(['next', 'cancel']);
const password = ref('');

const buttonClass = computed(() => {
  switch (props.role) {
    case 'student':
      return 'orange-button';
    case 'tutor':
      return 'teal-button';
    case 'institute':
      return 'yellow-button';
    default:
      return 'orange-button';
  }
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 24, 39, 0.295);
  padding: 1.5rem;
  backdrop-filter: blur(3px);
}

.modal-card {
  background: white;
  width: 100%;
  max-width: 45rem;
  padding: 4rem 3rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 20px -4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon-box {
  width: 3.5rem;
  height: 3.5rem;
  border: 1px solid;
}

.warning-bg {
  background: #FFF9EB;
  border-color: #FDE68A;
}

.warning-text {
  color: #F59E0B;
}

.title-brown {
  color: #6D4C20;
}

.error-placeholder {
  color: #dc2626;
  min-height: 1.25rem;
}

@media (max-width: 640px) {
  .modal-overlay { padding: 1rem; }
  .modal-card { padding: 2rem 1.25rem; }
}
</style>
